/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/

/**
 * bundle.js
 */

/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/
/**
 * Import.
 */
import { modules } from "./module/modules";
import smoothscroll from "smoothscroll-polyfill";

/**
 * iPhoneブラウザバック時リロード処理
 */
window.onpageshow = function (evt) {
	if (evt.persisted) {
		location.reload();
	}
};

/**
 * Passive Event Listener.
 */
document.addEventListener("touchstart", function () {}, { passive: true });

/**
 * 表示画面高さ取得
 */
const setFillHeight = () => {
	const vh = window.innerHeight * 0.01;
	document.documentElement.style.setProperty("--vh", `${vh}px`);
};
window.addEventListener("resize", setFillHeight);
setFillHeight();

/**
 * Run.
 */
modules();
smoothscroll.polyfill();

// scroll-hint
import ScrollHint from "scroll-hint";
new ScrollHint(".js-scrollable", {
	scrollHintIconClass: "scroll-hint-icon-svg", // class for the scroll hint
});

/**
 * Clear console.
 */
console.clear();

//デバッグ用です。はみ出したコンテンツに対して赤い枠線を表示

if (document.querySelector(".debug")) {
	const elements = document.querySelectorAll("*");
	elements.forEach((element) => {
		const rect = element.getBoundingClientRect();
		const isOutOfViewport = rect.top < 0 || rect.left < 0 || rect.bottom > window.innerHeight || rect.right > window.innerWidth;
		if (isOutOfViewport) {
			element.style.border = "1px solid red"; // 画面からはみ出したコンテンツに赤い枠線を適用
		}
	});
}
